export enum IdentifierClaims {
  NAME_IDENTIFIER_CLAIM = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier',
  ROLE_IDENTIFIER_CLAIM = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role',
  EMAIL_IDENTIFIER_CLAIM = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name',
}

export enum StorageVariables {
  RESEND_TIMER = 'resend_timer',
  CURRENT_USER = 'currentUser',
  ASIDE_STATE = 'aside_state',
  LANGUAGE = 'language',
  CUSTOMER = 'customer',
  THEME = 'theme',
  TOKEN = 'token',
}

export enum Roles {
  CUSTOMER = 'User',
  SECURITY = 'Security',
}

export enum ModalResponse {
  SUCCESS = 'success',
  CANCEL = 'cancel',
  ERROR = 'error',
}

export enum ApiVersions {
  V1 = 'v1',
  V3 = 'v3',
  V4 = 'v4',
}

export enum ModalResponse {
  Success = 'success',
  Cancel = 'cancel',
  Error = 'error',
}
